var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoPdf(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "4.11458in",
    height: "4.51667in",
    viewBox: "0 0 615 675",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#332C2B",
    strokeWidth: 24.9077,
    strokeLinejoin: "round",
    points: "76,12 435,12 539,116 539,663 76,663"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#332C2B",
    stroke: "#332C2B",
    strokeWidth: 20.7561,
    strokeLinejoin: "round",
    d: "M435 12l104 104 -52 0c-28,0 -52,-23 -52,-52l0 -52z"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#E62529",
    y: 280,
    width: 615,
    height: 293,
    rx: 21,
    ry: 21
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    fillRule: "nonzero",
    d: "M142 489l0 -126 40 0c16,0 26,1 31,2 7,2 13,6 18,12 5,7 7,15 7,25 0,8 -1,14 -4,20 -3,5 -6,9 -11,12 -4,3 -8,5 -13,6 -6,1 -15,2 -26,2l-17 0 0 47 -25 0zm25 -105l0 36 14 0c10,0 17,0 20,-2 3,-1 6,-3 8,-6 2,-3 3,-6 3,-10 0,-4 -1,-8 -4,-11 -3,-3 -6,-5 -10,-6 -3,0 -9,-1 -19,-1l-12 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    fillRule: "nonzero",
    d: "M259 363l47 0c10,0 18,1 24,2 7,3 13,7 19,12 5,6 9,13 12,21 2,8 4,18 4,29 0,11 -1,20 -4,27 -3,10 -8,17 -14,23 -4,4 -10,7 -17,10 -6,2 -14,2 -23,2l-48 0 0 -126zm26 21l0 84 19 0c7,0 12,0 15,-1 4,-1 8,-3 10,-5 3,-3 5,-7 7,-13 2,-5 3,-13 3,-23 0,-9 -1,-17 -3,-22 -2,-5 -4,-9 -7,-12 -3,-3 -7,-5 -12,-6 -4,-1 -10,-2 -21,-2l-11 0z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FEFEFE",
    fillRule: "nonzero",
    points: "387,489 387,363 473,363 473,384 412,384 412,414 465,414 465,436 412,436 412,489"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#332C2B",
    x: 163,
    y: 219,
    width: 289.554,
    height: 23.3514
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#332C2B",
    x: 163,
    y: 102,
    width: 201.594,
    height: 23.3514
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#332C2B",
    x: 163,
    y: 161,
    width: 289.554,
    height: 23.3514
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPdf);
export default __webpack_public_path__ + "static/media/logo_pdf.b418337dde4e6e69f8a83f6657d9e38d.svg";
export { ForwardRef as ReactComponent };